module.exports = {
          srcSet: __webpack_public_path__ + "public/images/f7453525527efc1108b15d87323c1296-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/f7453525527efc1108b15d87323c1296-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/f7453525527efc1108b15d87323c1296-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/f7453525527efc1108b15d87323c1296-1774.webp"},
          
          width: 1774,
          height: 887
        }